module.exports = __webpack_public_path__ + "img/object-mark6.14e3227c.png";